/* Carry the current selection into a quote without changing the cart flow. */
(() => {
  'use strict';
  if (customElements.get('tt-product-quote')) return;
  customElements.define('tt-product-quote', class extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('[data-product-quote-link]') || this.querySelector('a');
      this.listButton = this.querySelector('[data-quote-list-add]');
      this.sdsLink = this.querySelector('[data-product-sds]');
      if (!this.link) return;
      try { this.variants = JSON.parse(this.dataset.variants); } catch (_) { this.variants = []; }
      this.update = () => {
        const form = document.getElementById(this.dataset.formId);
        if (!form) return;
        const id = form.elements.namedItem('id')?.value;
        let selectedVariant = null;
        try {
          selectedVariant = JSON.parse(this.closest('product-info')?.querySelector('script[data-selected-variant]')?.textContent || 'null');
        } catch (_) { /* An incomplete selection keeps the existing safe fallback. */ }
        // The selected-variant response covers configurations beyond the initial Liquid variant list.
        const candidate = selectedVariant && String(selectedVariant.id) === String(id)
          ? selectedVariant
          : this.variants.find(item => String(item.id) === String(id));
        const picker = this.closest('product-info')?.querySelector('variant-selects');
        const requestedOptions = picker ? Array.from(picker.querySelectorAll('.product-form__input')).map(group => group.querySelector('select')?.value || group.querySelector('input:checked')?.value).filter(Boolean) : [];
        const selectionMatches = !requestedOptions.length || (Array.isArray(candidate?.options) && candidate.options.length === requestedOptions.length && candidate.options.every((value, index) => value === requestedOptions[index]));
        const variant = selectionMatches ? candidate : null;

        const url = new URL(this.link.href);
        // An unavailable option combination must not retain the previous SKU.
        url.searchParams.delete('sku');
        url.searchParams.delete('variant');
        if (variant) {
          if (variant.sku) url.searchParams.set('sku', variant.sku);
          if (variant.title !== 'Default Title') url.searchParams.set('variant', variant.title);
        }
        if (!variant) {
          const picker = this.closest('product-info')?.querySelector('variant-selects');
          const requested = picker ? Array.from(picker.querySelectorAll('select,input:checked')).map(input => input.value).filter(Boolean) : [];
          if (requested.length) url.searchParams.set('variant', requested.join(' / '));
        }
        const quantity = form.elements.namedItem('quantity')?.value;
        url.searchParams.delete('quantity');
        if (/^[1-9]\d*$/.test(quantity || '')) url.searchParams.set('quantity', quantity);
        this.link.href = url.href;
        this.quoteSelection = variant ? {
          productId: this.dataset.productId, variantId: String(variant.id), title: this.dataset.productTitle,
          vendor: this.dataset.productVendor, sku: variant.sku || '', configuration: variant.title || '',
          quantity: quantity || '1', url: this.dataset.productUrl, image: this.dataset.productImage || ''
        } : null;
        if (this.listButton) this.listButton.disabled = !variant || !/^[1-9]\d{0,5}$/.test(quantity || '1');
        if (this.sdsLink) {
          const sdsUrl = new URL(this.sdsLink.href);
          sdsUrl.searchParams.delete('sku');
          if (variant?.sku) sdsUrl.searchParams.set('sku', variant.sku);
          this.sdsLink.href = sdsUrl.href;
        }
      };
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const quoteForm = document.getElementById(this.dataset.formId);
      if (quoteForm?.dataset.quoteOnly === 'true') {
        quoteForm.addEventListener('submit', event => {
          event.preventDefault();
          this.update();
          this.link.click();
        }, options);
      }
      // Ignore stale variant IDs while a newly chosen option is loading.
      this.closest('product-info')?.addEventListener('change', this.update, options);
      quoteForm?.addEventListener('input', this.update, options);
      for (const event of ['focus', 'pointerenter', 'click', 'contextmenu']) {
        this.link.addEventListener(event, this.update, options);
        this.sdsLink?.addEventListener(event, this.update, options);
      }
      if (this.listButton) {
        const enableList = () => {
          const enabled = !!window.TechToolQuoteList;
          this.listButton.hidden = !enabled;
          this.classList.toggle('tt-product-quote--shortlist', enabled);
          this.listButton.classList.toggle('btn--primary', quoteForm?.dataset.quoteOnly === 'true');
          this.listButton.classList.toggle('btn--secondary', quoteForm?.dataset.quoteOnly !== 'true');
          const label = this.querySelector('[data-product-quote-label]');
          if (enabled && label && this.dataset.singleQuoteLabel) label.textContent = this.dataset.singleQuoteLabel;
        };
        document.addEventListener('tt:quote-list:ready', enableList, options);
        enableList();
        this.listButton.addEventListener('click', () => {
          this.update();
          if (this.quoteSelection && window.TechToolQuoteList) window.TechToolQuoteList.add(this.quoteSelection, this.listButton);
        }, options);
      }
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
})();



